// File: frontend/src/views/public/Home.js

import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import ScrollAnimation from '../../components/common/ScrollAnimation';
import Hero from '../../components/pages/home/Hero';
import TrustedCompanies from '../../components/pages/home/TrustedCompanies';
import HowItWorks from '../../components/pages/home/HowItWorks';
import Features from '../../components/pages/home/Features';
import TrustSection from '../../components/pages/home/TrustSection';
// import PricingLanding from '../../components/pages/home/PricingLanding';
import FAQ from '../../components/pages/home/FAQ';
import CTA from '../../components/pages/home/CTA';
import styles from './Home.module.css';
import SEO from '../../components/utility/SEO';
import { SEO_CONFIG } from '../../config/seo';

const Home = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const [showChat, setShowChat] = useState(false);
  const seo = SEO_CONFIG.home;

  const handleChatClick = () => {
    setShowChat(true);
  };

  if (authLoading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner}></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        image={seo.image}
      />
      <div className={styles.home}>
        {/* 1. Hero */}
        <Hero />

        {/* 2. Trust bar */}
        <TrustedCompanies />

        {/* 3. How It Works - ID already exists in component */}
        <ScrollAnimation>
          <HowItWorks />
        </ScrollAnimation>

        {/* 4. Features - ID already exists in component */}
        <Features />

        {/* 5. Trust & Security */}
        <TrustSection />

        {/* 6. Pricing - ID already exists in component */}
        {/* <ScrollAnimation>
          <PricingLanding />
        </ScrollAnimation> */}

        {/* 7. FAQ */}
        <ScrollAnimation>
          <FAQ onChatClick={handleChatClick} />
        </ScrollAnimation>

        {/* 8. Final CTA */}
        {!isAuthenticated && <CTA />}
      </div>
    </>
  );
};

export default Home;